import React, { useState } from "react";
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
    Label,
    Input
} from "reactstrap";
import { toast } from "react-toastify";
import { useMutationRequestQuery } from "../../../../Hooks/useMutationRequestQuery";
import { uploadLeadDocumentService } from "../../../../Services/CRMAdminServices/CRMTaskListService";
import { useQueryClient } from "@tanstack/react-query";

// Define the type for props
interface FileUploadProps {
    toggle: () => void;
    open: boolean;
    leadId: string | any; // Lead ID to associate document
}

const FileUpload: React.FC<FileUploadProps> = ({ toggle, open, leadId }) => {
    const [selectedFile, setSelectedFile] = useState<File | null>(null);
    const queryClient = useQueryClient();

    const {
        mutate: uploadDocument,
        isPending: isUploading,
    } = useMutationRequestQuery("uploadLeadDocument", uploadLeadDocumentService, {
        onSuccess: () => {
            toast.success("Document uploaded successfully.");
            queryClient.invalidateQueries({ queryKey: ["getCRMLeadDocuments"] });
            toggle();
        },
        onError: () => {
            toast.error("Failed to upload document.");
        },
    });

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files && event.target.files.length > 0) {
            setSelectedFile(event.target.files[0]);
        }
    };

    const handleUpload = () => {
        if (selectedFile) {
            uploadDocument({ leadId, file: selectedFile });
        } else {
            toast.warning("Please select a file to upload.");
        }
    };

    return (
        <Modal isOpen={open} toggle={toggle} size="lg">
            <ModalHeader toggle={toggle}>Upload File</ModalHeader>
            <ModalBody>
                <Label for="fileUpload" className="fw-bold">
                    Select File
                </Label>
                <Input
                    type="file"
                    id="fileUpload"
                    onChange={handleFileChange}
                    accept="*/*"
                />
            </ModalBody>
            <ModalFooter>
                <Button color="primary" onClick={handleUpload} disabled={isUploading}>
                    {isUploading ? "Uploading..." : "Upload"}
                </Button>
                <Button color="secondary" onClick={toggle}>
                    Cancel
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default FileUpload;
